import { render, staticRenderFns } from "./suspendedAccounts.vue?vue&type=template&id=116a78a1&scoped=true"
import script from "./suspendedAccounts.vue?vue&type=script&lang=js"
export * from "./suspendedAccounts.vue?vue&type=script&lang=js"
import style0 from "./suspendedAccounts.vue?vue&type=style&index=0&id=116a78a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a78a1",
  null
  
)

export default component.exports